import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom"
import { ROUTES } from "@/helpers/routes"
import { Button } from "@/ui/Button"
import styles from "./Referrals.module.scss"
import { CommissionsTab, DetailsTab, FriendsTab } from "./ui"

const REFERRALS_TABS = [
  {
    segment: "details",
    label: "referrals.tabs.details",
    path: ROUTES.REFERRALS_DETAILS,
    Component: DetailsTab
  },
  {
    segment: "commissions",
    label: "referrals.tabs.commissions",
    path: ROUTES.REFERRALS_COMMISSIONS,
    Component: CommissionsTab
  },
  {
    segment: "friends",
    label: "referrals.tabs.friends",
    path: ROUTES.REFERRALS_FRIENDS,
    Component: FriendsTab
  }
] as const

export const Referrals: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className={styles.Referrals}>
      <div className={styles.Referrals_title}>{t("referrals.title")}</div>
      <div className={styles.Referrals_inner}>
        <div className={styles.Referrals_content}>
          <div className={styles.Referrals_content_header}>
            <div className={styles.Referrals_nav}>
              <Button.Back link={ROUTES.HOME} />
            </div>
            <div className={styles.Referrals_content_switcher} role="tablist">
              {REFERRALS_TABS.map(({ segment, label, path }) => (
                <button
                  key={segment}
                  type="button"
                  role="tab"
                  aria-selected={location.pathname === path}
                  className={clsx(styles.Referrals_content_switcher_item, {
                    [styles.active]: location.pathname === path
                  })}
                  onClick={() => navigate(path)}
                >
                  {t(label)}
                </button>
              ))}
            </div>
          </div>
          <div className={styles.Referrals_content_body}>
            <Routes>
              <Route index element={<Navigate to="details" replace />} />
              {REFERRALS_TABS.map(({ segment, Component }) => (
                <Route key={segment} path={segment} element={<Component />} />
              ))}
            </Routes>
          </div>
        </div>
      </div>
    </div>
  )
}
